import _lodash,{get} from 'lodash'
import { message,Tooltip } from 'antd'
import {QuestionCircleOutlined} from '@ant-design/icons'
import React from 'react'

var checkData = {}
const isEmpty = (key)=>{
  if(!get(checkData,key)||get(checkData,key)=='0'){
    return true
  }
  return false
}

const isEmptyIncludes0 = (key)=>{

  if(!get(checkData,key)&&get(checkData,key)!='0'||(get(checkData,key) instanceof Array)&&!get(checkData,key+'.length')){
    return true
  }
  return false
}
const isEmptyData= (data)=>{
  if(!data&&data!='0'){
    return true
  }
  return false
}
export const basicInformationRequiredverificationFun = (addData, categoryid) => {
  console.log(addData)
  const isCrossborder = addData.item_info.is_cross_border == 1
  checkData = addData
  let _flagExtend = true
  let _flagSku = true
  if (!['3', '5', '7', '21'].includes(categoryid)) {
    isEmptyIncludes0('item_info.item_name', '请输入商品名称')
    if (isEmptyIncludes0('item_info.item_name')) {
      message.warning('请输入商品名称', 2)
      return false
    }
  }
  if (isEmptyIncludes0('item_info.brand_id')) {
    message.warning('请选择商品品牌', 2)
    return false
  }

  if (['3', '5', '7', '21'].includes(categoryid)) {
    if (isEmptyIncludes0('item_info.item_series')) {
      message.warning('请填写商品系列', 2)
      return false
    }
  }
  if (isEmptyIncludes0('item_info.item_color_type')) {
    message.warning('请选择类型', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.spec')) {
    message.warning('请选择规格', 2)
    return false
  }
  // if (isEmptyIncludes0('item_info.spec_unit')) {
  //   message.warning('请选择规格单位', 2)
  //   return false
  // }
  if (['3'].includes(categoryid)) {
    if (isEmptyIncludes0('item_info.item_material')) {
      message.warning('请选择商品材质', 2)
      return false
    }
  }
  if (!get(addData, 'item_info.is_long_expiration') && isEmpty('item_info.item_useful_life')) {
    message.warning('请选择产品有效期', 2)
    return false
  }
  if (!get(addData, 'item_info.is_long_expiration') && isEmptyIncludes0('item_info.useful_unit')) {
    message.warning('请选择产品有效期单位', 2)
    return false
  }
  if (['3'].includes(categoryid)) {
    if (isEmptyIncludes0('item_info.is_customed')) {
      message.warning('请选择是否散光片', 2)
      return false
    }
  }
  if(['3', '5', '7'].includes(categoryid)&&get(addData,'item_info.is_cross_border') == '0'){
    if (isEmptyIncludes0('item_info.is_import')) {
      message.warning('请选择是否进口', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.origin_place')) {
      message.warning('请选择产地', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.produce_type')) {
      message.warning('请选择生产方式', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.medical_name')) {
      message.warning('请选择医疗器械名称', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.main_function')) {
      message.warning('请输入主要功能', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.pro_model')) {
      message.warning('请输入型号及规格', 2)
      return false
    }
    if (!get(addData,'item_info.storages.length')) {
      message.warning('请选择存储要求', 2)
      return false
    }
  }
  if (!get(addData,'item_info.weight')) {
    message.warning('请填写单品重量', 2)
    return false
  }
  const _weight = get(addData,'item_info.weight')
  if (_weight !== undefined && _weight !== null && _weight !== '' && String(_weight).includes('.')) {
    const _decimalPart = String(_weight).split('.')[1]
    if (_decimalPart && _decimalPart.length > 2) {
      message.warning('单品重量最多支持两位小数', 2)
      return false
    }
  }
  if (!get(addData,'item_info.packing_specification')||get(addData,'item_info.packing_specification')=='0') {
    message.warning('请填写箱规', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.create_company')) {
    message.warning('请填写生产企业', 2)
    return false
  }
  if(get(addData,'item_info.is_cross_border') === 1){
    if (isEmptyIncludes0('item_info.english_name')) {
      message.warning('请填写商品英文名称', 2)
      return false
    }
    if (isEmptyIncludes0('item_info.origin_place')) {
      message.warning('请选择产地', 2)
      return false
    }
  }

  // 隐形眼镜
  if (['3'].includes(categoryid)) {
    if (isEmptyIncludes0('contact_property.change_cycle')) {
      message.warning('请选择更换周期', 2)
      return false
    }
    // if (isEmptyIncludes0('contact_property.water')) {
    //   message.warning('请填写含水量', 2)
    //   return false
    // }
    // 非海淘
    if (!isCrossborder) {
      // if (isEmptyIncludes0('contact_property.refraction')) {
      //   message.warning('请填写折射率', 2)
      //   return false
      // }
      // if (isEmptyIncludes0('contact_property.oxygen')) {
      //   message.warning('请填写透氧系数', 2)
      //   return false
      // }
      // if (isEmptyIncludes0('contact_property.oxy_unit')) {
      //   message.warning('请选择透氧系数单位', 2)
      //   return false
      // }
      // for (let item1 in addData.contact_property['thickness_list']) {
      //   var thickness = addData.contact_property['thickness_list'][item1]
      //   if (!get(thickness, 'thickness_begin')) {
      //     message.warning('请填写中心厚度范围', 2)
      //     return false
      //   }
      //   if (!get(thickness, 'thickness_end')) {
      //     message.warning('请填写中心厚度范围', 2)
      //     return false
      //   }
      //   if (!get(thickness, 'thickness')) {
      //     message.warning('请填写中心厚度的对应厚度', 2)
      //     return false
      //   }
      // }
    }

    //彩色隐形眼镜才校验
    // if (get(addData, 'item_info.item_color_type_name')&&get(addData, 'item_info.item_color_type_name').includes('彩色')) {
    //   _lodash.forEach(addData.extend_color_properties, (item, index) => {
        
    //     // if (!get(item, 'color')) {
    //     //   message.warning('请选择花色', 2)
    //     //   _flagExtend = false
    //     //   return false
    //     // }
    //     // if (!get(item, 'base_arc')) {
    //     //   message.warning('请选择基弧', 2)
    //     //   _flagExtend = false
    //     //   return false
    //     // }
    //     // if (!get(item, 'dia')) {
    //     //   message.warning('请选择直径', 2)
    //     //   _flagExtend = false
    //     //   return false
    //     // }
    //     // if (get(addData, 'item_info.item_color_type_name').includes('彩色') && !get(item, 'color_dia')) {
    //     //   message.warning('请选择着色直径', 2)
    //     //   _flagExtend = false
    //     //   return false
    //     // }
    //   })
    //   if(!_flagExtend){
    //     return _flagExtend
    //   }
    //      }
    const judgeData = (addData.degrees || []).filter(el => el.length > 0)
    if (judgeData.length === 0) {
      message.warning('请选择光度', 2)
      return false
    }

  } else {
    _lodash.forEach(addData.extend_propertys, (item, index) => {
      if (item.is_required === 1) {
        if (!item.extend_value) {
          message.warning('请输入' + item.property_name, 1.5)
          _flagExtend = false
        }
      }
    })
    if (!_flagExtend) {
      return false
    }
    _lodash.forEach(addData.sku_propertys, (item, index) => {
      if (item.is_required === 1) {
        let isRequired = true
        // item.sku_value.forEach(_item => {
        //   if (!_item&&_item!='0') {
        //     isRequired = false
        //     _flagSku = false
        //   }
        // })
        if (!get(item,'sku_value.length')) {
          message.warning('请输入' + item.property_name, 1.5)
          _flagSku = false
        }
      }
    })
    if (!_flagSku) {
      return false
    }
  }
}

export const cooperationInformationRequiredverificationFun = (addData,twoType,isOemBrand) => {
  console.log(addData)
  checkData = addData
  if (isEmptyIncludes0('item_info.operation')) {
    message.warning('请选择经营属性', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.is_one_sale')) {
    message.warning('请选择是否独家销售', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.pay_type')) {
    message.warning('请选择账期', 2)
    return false
  }

  if (get(addData,'item_info.pay_type') === '滚动账期') {
    if (isEmpty('item_info.pay_day')) {
      message.warning('请选择滚动账期天数', 2)
      return false
    }
  }
  if (['固定账期','实销实结'].includes(get(addData,'item_info.pay_type') )) {
    if (isEmptyIncludes0('item_info.pay_day')) {
      message.warning('请选择固定账期天数', 2)
      return false
    }
  }

  if ([1,3].includes(twoType)) {
    if (isEmpty('item_info.trade_code')) {
      message.warning('请选择贸易术语', 2)
      return false
    }
  }

  if (isEmptyIncludes0('item_info.tax_rate')) {
    message.warning('请填写税率', 2)
    return false
  }

  if (twoType==1) {
    if (isEmptyIncludes0('item_info.base_price')) {
      message.warning('请填写工厂出厂价', 2)
      return false
    }
    if (isEmpty('item_info.currency')) {
      message.warning('请选择工厂出厂价的币种', 2)
      return false
    }
    // if (isEmptyIncludes0('item_info.settle_price')) {
    //   message.warning('工厂出厂价-含税结算价不能为空', 2)
    //   return false
    // }
  }else{
    if (isEmptyIncludes0('item_info.base_price')) {
      message.warning('请填写含税结算单价', 2)
      return false
    }
    if (isEmpty('item_info.currency')) {
      message.warning('请选择含税结算单价的币种', 2)
      return false
    }
  }
  if(!twoType){
    if (isEmptyIncludes0('item_info.settle_price')) {
      message.warning('含税结算价不能为空', 2)
      return false
    }
  }
  if([1,2].includes(twoType)&&isOemBrand){
    //twoType:1,2,3时且是oem品牌时间
    if (isEmptyIncludes0('item_info.is_have_brand_fee')) {
      message.warning('请选择是否有品牌使用费', 2)
      return false
    }
    if(get(addData, 'item_info.is_have_brand_fee')){
      if (isEmptyIncludes0('item_info.brand_fee')) {
        message.warning('请填写品牌费含税单价', 2)
        return false
      }
      if (isEmpty('item_info.brand_currency')) {
        message.warning('请选择品牌费含税单价的币种', 2)
        return false
      }
      if (isEmpty('item_info.brand_sid')) {
        message.warning('请选择品牌方', 2)
        return false
      }
    }
  }
  if(twoType){
    if (isEmptyIncludes0('item_info.settle_price')) {
      message.warning('含税结算成本不能为空', 2)
      return false
    }
  }

  if (isEmptyIncludes0('item_info.price_unit')) {
    message.warning('请填写计价单价', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.produce_cycle')) {
    message.warning('请填写生产周期', 2)
    return false
  }
  if (isEmpty('item_info.delivery_day')) {
    message.warning('请填写发货天数', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.sale_price')) {
    message.warning('请填写建议零售价', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.is_supply_complaint')) {
    message.warning('请选择售后处理类型', 2)
    return false
  }
  if (isEmpty('item_info.after_sale_problem')) {
    message.warning('请选择售后处理方式', 2)
    return false
  }
  if (isEmptyIncludes0('item_info.is_rebate')) {
    message.warning('请选择有无返利', 2)
    return false
  }

  if (addData.item_info.is_rebate === 1) {
    if (isEmpty('item_info.rebate_point')) {
      message.warning('请填写返利点数', 2)
      return false
    }
    if (isEmpty('item_info.rebate_base')) {
      message.warning('请选择返利基数', 2)
      return false
    }
    if (isEmpty('item_info.rebate_note')) {
      message.warning('请选择返利生成时间点', 2)
      return false
    }
    if (isEmpty('item_info.rebate_type')) {
      message.warning('请选择兑现方式', 2)
      return false
    }
  }
}
export const periodicDataConversion = (value) => {
  if (value === 'Day') {
    return '日抛'
  }

  if (value === 'Week') {
    return '周抛'
  }

  if (value === 'Fortnight') {
    return '双周抛'
  }

  if (value === 'Month') {
    return '月抛'
  }

  if (value === 'TwoMonths') {
    return '双月抛'
  }

  if (value === 'Quarter') {
    return '季抛'
  }

  if (value === 'SixMonths') {
    return '半年抛'
  }

  if (value === 'Year') {
    return '年抛'
  }
}

export const statusChineseConversion = (status) => {
  if (status) {
    if (status === 'to_submit') {
      return '待提交'
    }
    if (status === 'to_check') {
      return '待审核'
    }
    if (status === 'on_check') {
      return '审核中'
    }
    if (status === 'pass_check') {
      return '审核通过'
    }
    if (status === 'refuse_check') {
      return '审核拒绝'
    }
    if (status === 'to_edit') {
      return '返回修改'
    }
    if (status === 'closed') {
      return '已关闭'
    }
  } else {
    return '-'
  }
}
export const approvalResultFunc = (status) => {
  if (status) {
    if (status === 'to_import') {
      return '待引入'
    }
    if (status === 'pass_import') {
      return '引入成功'
    }
    if (status === 'refuse_import') {
      return '引入失败'
    }
  } else {
    return '-'
  }
}

export const priceUnitFunc = (value) => {
  let prcUnit =  [
    {
        "children": [],
        "dict_key": "只",
        "dict_name": "只",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "支",
        "dict_name": "支",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "副",
        "dict_name": "副",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "片",
        "dict_name": "片",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "盒",
        "dict_name": "盒",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "瓶",
        "dict_name": "瓶",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "个",
        "dict_name": "个",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "件",
        "dict_name": "件",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "把",
        "dict_name": "把",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "条",
        "dict_name": "条",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "块",
        "dict_name": "块",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "台",
        "dict_name": "台",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "罐",
        "dict_name": "罐",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "套",
        "dict_name": "套",
        "is_batch": null
    },
    {
        "children": [],
        "dict_key": "卷",
        "dict_name": "卷",
        "is_batch": null
    }
]
  return prcUnit
}


export const getSettlePriceTooltipText=(twoType)=>{
  var textObj = {
    2:"含税结算单价+品牌费含税单价",
    3:<div>
      含税结算单价*汇率+估算运费
      <div>DAP：0.1元</div>
      <div>CIF：0.15元</div>
      <div>FOB：0.2元</div>
      <div>FCA：0.2元</div>
      <div>EXW：0.25元</div>
    </div>,
    1:<div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>DDP</span>：工厂出厂价*汇率+品牌费含税单价*汇率</div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>DAP</span>：（工厂出厂价*汇率）*1.06*1.13+品牌费含税单价*汇率+估算运费0.1元</div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>CIF</span>：（工厂出厂价*汇率）*1.06*1.13+品牌费含税单价*汇率+估算运费0.15元</div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>FOB</span>：（工厂出厂价*汇率）*1.06*1.13+品牌费含税单价*汇率+估算运费0.2元</div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>FCA</span>：（工厂出厂价*汇率）*1.06*1.13+品牌费含税单价*汇率+估算运费0.2元</div>
      <div><span style={{display:"inline-block",width:30,textAlign:"right"}}>EXW</span>：（工厂出厂价*汇率）*1.06*1.13+品牌费含税单价*汇率+估算运费0.25元</div>
    </div>

  }
  return <Tooltip title={textObj[twoType] } overlayStyle={{maxWidth:520}}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>
}


// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/utils.js